import { Content } from "@/ui";
import { getRoute } from "@/getters/getRoute";
import { case_study_helper } from "@/helpers/case_study_helper";
import * as additionalComponents from "./__components";
import { createTitle } from "@/functions/createTitle";
import sn from "@/snippets";
import { candidate_testimonies_helper } from "@/helpers/candidate_testimonies_helper";

export default function CaseStudyPage({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({ params: { url_slug } }) {
  const casestudy = case_study_helper.find(url_slug);

  // const findStat = casestudy.stat_counter_items?.en?.map((i) => ({
  //         label : i.label,
  //         value: i.value,
  //       }))

  return {
    props: {
      meta: {
        title: createTitle(casestudy.title, "Case Studies", "Recruitment Solutions"),
        canonical: "https://www.bluearrow.co.uk" + getRoute("caseStudy", { url_slug: url_slug }),
      },
      content: [
        {
          component: "BreadcrumbNavigation",
          props: {
            items: [
              { label: "Recruitment Solutions", href: "/recruitment-solutions/why-choose-blue-arrow/" },
              { label: "Case Studies", href: getRoute("caseStudies") },
              { label: casestudy.title, href: getRoute("caseStudy", { url_slug }) },
            ],
          },
        },
        {
          component: "Header",
          props: {
            className: "text-white bg-tertiary",
            title: casestudy.title ?? null,
            img: casestudy.cover_image ?? null,
            variant: casestudy["header_image_position"] ?? "Under Text",
            back: {
              path: "page.caseStudy.component.Header.back",
              placeholder: `Back to Case Studies`,
              href: getRoute("caseStudies"),
            },
          },
        },
        // ...sn.statCounterWidget({ ...casestudy, after: { component: "Divider" } }),
        {
          component: "StatCounterWidget",
          props: {
            items: casestudy?.stat_counter_items.map((i) => ({
              label: i.label ?? null,
              value: i.value ?? null,
              prefix: i.value_prefix ?? null,
              suffix: i.value_suffix ?? null,
            })),
          },
        },

        { component: "CaseStudyContent", props: { ...casestudy } },
        ...sn.narrativePanels({
          className: "mb-4 pb-md-5",
          items: casestudy.narrative_panels ?? [],
        }),
        // {
        //   component: "BlockQuote",
        //   props: {
        //     className: `bg-light-grey py-4 py-md-5`,
        //     items: candidate_testimonies_helper
        //       .fetch({ limit: 12 })
        //       .filter((v) => v.candidate_client?.includes("Client"))
        //       .map((quote) => ({
        //         quote: quote.quote,
        //         // author: {
        //         //   name: quote.author_name,
        //         //   position: quote.author_postion,
        //         // },
        //       })),
        //     visibleCount: 1,
        //     carousel: true,
        //   },
        // },
        {
          component: "CaseStudies",
          props: {
            title: {
              path: `page.caseStudy.${url_slug}.component.CaseStudies.title`,
              placeholder: "Other Case Studies you might like",
            },
            items: case_study_helper.fetch({ limit: 3, exclude: [casestudy.id] }),
          },
        },
        {
          component: "Chatbot",
          props: {
            chatbot: casestudy.chatbot ?? null,
          },
        },
      ],
    },
  };
}

export async function getStaticPaths() {
  return {
    paths: case_study_helper.toPaths(),
    fallback: false,
  };
}
